@if (workspaceTabs.tabs().length) {
  <div class="workspace-tabs-bar flex items-center print:hidden" role="toolbar" aria-label="Open pages">
    <div
      #tabsScroll
      class="workspace-tabs-scroll min-w-0 flex-1"
      cdkDropList
      cdkDropListOrientation="horizontal"
      cdkDropListAutoScrollDisabled
      (cdkDropListDropped)="onTabDrop($event)"
    >
      @for (group of tabGroups(); track trackByTabGroupKey($index, group)) {
        @if (group.tabs.length === 1 && !group.forceDropdown) {
          @let tab = group.tabs[0];
          <div
            class="workspace-tab"
            cdkDrag
            cdkDragPreviewContainer="parent"
            [cdkDragConstrainPosition]="workspaceTabs.keepTabDragOnStrip"
            [class.workspace-tab-active]="workspaceTabs.activeTabId() === tab.id"
            role="presentation"
            (cdkDragStarted)="onTabDrag(true)"
            (cdkDragMoved)="onTabDragMoved()"
            (cdkDragEnded)="onTabDrag(false)"
          >
            <button
              type="button"
              cdkDragHandle
              class="workspace-tab-label"
              (click)="select(tab)"
              matTooltipPosition="below"
              [matTooltip]="tabTooltip(tab.id)"
              [matTooltipDisabled]="!tabTooltip(tab.id)"
              [attr.aria-current]="workspaceTabs.activeTabId() === tab.id ? 'page' : null"
            >
              {{ tab.title }}
            </button>
            <button
              type="button"
              class="workspace-tab-close"
              aria-label="Close tab"
              (click)="close(tab, $event)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <div class="workspace-tab-drag-preview" *cdkDragPreview>{{ tab.title }}</div>
          </div>
        } @else {
          <app-workspace-tab-module-group [group]="group" />
        }
      }
    </div>
    <button
      type="button"
      class="relative mr-0.5 inline-flex h-4 w-4 shrink-0 cursor-pointer items-center justify-center rounded border border-slate-300/70 bg-slate-200/95 p-0 text-blue-800 before:absolute before:-inset-x-1 before:-inset-y-0.5 before:content-[''] hover:border-blue-400/60 hover:bg-blue-100 hover:text-blue-700 aria-expanded:border-blue-400/60 aria-expanded:bg-blue-100 aria-expanded:text-blue-700 dark:border-slate-600 dark:bg-slate-700/95 dark:text-blue-300 dark:hover:border-blue-400/55 dark:hover:bg-blue-900/45 dark:hover:text-blue-200 dark:aria-expanded:border-blue-400/55 dark:aria-expanded:bg-blue-900/45 dark:aria-expanded:text-blue-200"
      aria-label="Tab actions"
      matTooltip="Tab actions"
      matTooltipPosition="below"
      [matMenuTriggerFor]="tabActionsMenu"
    >
      <mat-icon class="!h-3.5 !w-3.5 !text-[14px] !leading-none">more_vert</mat-icon>
    </button>
    <mat-menu #tabActionsMenu="matMenu" xPosition="before">
      <!-- <button
        mat-menu-item
        type="button"
        aria-disabled="true"
        class="!h-7 !min-h-7 !cursor-default !rounded !px-2 !text-xs !font-semibold !leading-7 !text-slate-700 hover:!bg-slate-100 dark:!text-slate-200 dark:hover:!bg-slate-700/60"
        matTooltip="Coming soon"
        matTooltipPosition="left"
        (click)="$event.preventDefault(); $event.stopPropagation()"
      >
        <mat-icon class="!mr-1.5 !h-3.5 !w-3.5 !text-[14px] !text-amber-500">star</mat-icon>
        <span>Favorite pages</span>
      </button>
      <button
        mat-menu-item
        type="button"
        aria-disabled="true"
        class="!h-7 !min-h-7 !cursor-default !rounded !px-2 !text-xs !font-semibold !leading-7 !text-slate-700 hover:!bg-slate-100 dark:!text-slate-200 dark:hover:!bg-slate-700/60"
        matTooltip="Coming soon"
        matTooltipPosition="left"
        (click)="$event.preventDefault(); $event.stopPropagation()"
      >
        <mat-icon class="!mr-1.5 !h-3.5 !w-3.5 !text-[14px] !text-blue-500">history</mat-icon>
        <span>Frequently used pages</span>
      </button> -->
      <button
        mat-menu-item
        type="button"
        class="!h-7 !min-h-7 !rounded !bg-red-500/10 !px-2 !text-xs !font-semibold !leading-7 !text-orange-900 hover:!bg-red-500/20 focus:!bg-red-500/20"
        (click)="closeAll()"
      >
        <mat-icon class="!mr-1.5 !h-3.5 !w-3.5 !text-[14px] !text-red-500">close</mat-icon>
        <span>Close all tabs and sub tabs</span>
      </button>
    </mat-menu>
  </div>
}
